import React from "react";
import {Form} from ".";
import {typeStateCategories} from "../Layout";
import {EmailConfirmation} from "../EmailConfirmation";

interface FormControlProps extends typeStateCategories {
	selectedShortName: string;
}

export type FormDataReducer = {
	type: 'SET_USERNAME' | 'SET_EMAIL' | 'SET_TERMS' | 'SUBMIT_FORM' | 'SET_PASSWORD';
	payload?: string;
}

type FormData = {
	username: string;
	email: string;
	password: string;
	terms: string;
	submitted: string;
}

export type formReducer = React.Dispatch<FormDataReducer>;
export type PartialFormData = Partial<FormData>;

export const FormControl = ({selectedShortName, state}: FormControlProps) => {
	const initialFormData: PartialFormData = {username: '', email: '', terms: '', submitted: '', password: ''};
	const reducer = (state: typeof initialFormData, action: FormDataReducer) => {
		switch (action.type) {
			case 'SET_USERNAME':
				return {...state, username: action.payload};
			case 'SET_EMAIL':
				return {...state, email: action.payload};
			case 'SET_TERMS':
				return {...state, terms: action.payload};
			case 'SET_PASSWORD':
				return {...state, password: action.payload};
			case 'SUBMIT_FORM':
				// Here you can handle form submission logic if needed
				return {...state, submitted: 'submitted'};
			default:
				return state;
		}
	}
	const [formData, dispatch] = React.useReducer(reducer, initialFormData);

	if (!formData.submitted) {
		return <Form state={state} selectedShortName={selectedShortName} formDispatcher={dispatch}/>
	}

	return <EmailConfirmation {...formData} />
}
